import { gql } from '@apollo/client';

export const CHECK_CRITICAL_ACTION_QUERY = gql`
  query CheckCriticalActionQuery($action: String!, $agentID: ID!, $email: String!) {
    checkCriticalAction(action: $action, agentID: $agentID, email: $email) {
      agentID
      action
      active
    }
  }
`;
